import { forwardRef, type Ref, type SVGProps } from "react";
const IconCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 16C2 8.268 8.268 2 16 2a14 14 0 0 1 14 14c0 7.732-6.268 14-14 14S2 23.732 2 16m26 0c0-6.627-5.373-12-12-12S4 9.373 4 16s5.373 12 12 12 12-5.373 12-12"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCircleOutlineSVG);
ForwardRef.displayName = "IconCircleOutline";
export { ForwardRef as IconCircleOutline };
